import React, { useState } from "react";
import "./SignIn.css";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./UseAuth";
import { useSearchParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const SignIn = () => {
  const navigate = useNavigate();
  const [apiError, setApiError] = useState(null);
  const { register, handleSubmit, watch, errors } = useForm();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const auth = useAuth();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const onSubmit = (data) => {
    auth
      .resetPassword(data.password, token)
      .then((data) => {
        setApiError(data.message);
      })
      .catch((err) => setApiError(err.message));
  };

  const resetPasswordForm = (
    <form onSubmit={handleSubmit(onSubmit)} className="py-5">
      <div className="form-group">
        <div style={{ position: "relative" }}>
          <input
            type={showPassword ? "text" : "password"}
            name="password"
            className="form-control"
            ref={register({ required: true })}
            placeholder="*Password"
          />
          <FontAwesomeIcon
            icon={showPassword ? faEye : faEyeSlash}
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: "absolute",
              right: "15px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "#6c757d",
            }}
          />
        </div>
        {errors.password && <span className="error">Password is required</span>}
      </div>
      <div className="form-group">
        <div style={{ position: "relative" }}>
          <input
            type={showConfirmPassword ? "text" : "password"}
            name="confirm_password"
            className="form-control"
            ref={register({
              validate: (value) => value === watch("password"),
            })}
            placeholder="*Confirm Password"
          />
          <FontAwesomeIcon
            icon={showConfirmPassword ? faEye : faEyeSlash}
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            style={{
              position: "absolute",
              right: "15px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "#6c757d",
            }}
          />
        </div>
        {errors.confirm_password && (
          <span className="error">Passwords don't match.</span>
        )}
      </div>
      <div className="form-group">
        <button className="btn btn-danger btn-block shadow gradient-bg-accent" type="submit">
          Submit
        </button>
      </div>

      {apiError && <span className="error">{apiError}</span>}

      <div className="option text-center">
        <label onClick={() => navigate("/signin")}>Sign in</label>
      </div>
    </form>
  );

  return (
    <div className="sign-up">
      <div className="container">
        <div className="logo text-center py-4"></div>
        {resetPasswordForm}
      </div>
    </div>
  );
};

export default SignIn;
